import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import assets from 'assets';

import SignUpPrompts from './SignUpPrompts';
import UpgradePrompt from './UpgradePrompt';
import ConfirmationModel from 'container/Dialogs/ConfirmationModel/ConfirmationModel';

// import ReferralProgram from 'container/components/ReferralProgram/ReferralProgram';
import Spinner from 'container/components/Spinner';
import { Tooltip } from 'react-tooltip';
import theme from 'container/theme';
// import OfferSlider from 'container/components/OfferSlider/OfferSlider';

function UserDetails({ setSignUpModal, setSubscriptionModal, setMobileMenu }) {
  const dispatch = useDispatch();
  const planData = useSelector(state => state.subscription.planData);
  const user = useSelector(state => state.auth.user);
  const token = localStorage.getItem('token');
  const loading = useSelector(state => state.subscription.planLoading);
  const dLoading = useSelector(state => state.auth.dLoading);

  const renderPlanType = () => {
    if (user?.profile?.status === 5) {
      return 'Paused';
    }
    if (planData?.plan.toLowerCase() === 'month') {
      return 'Monthly';
    } else if (planData?.plan.toLowerCase() === 'year') {
      return 'Annual';
    } else if (planData?.plan.toLowerCase() === 'free') {
      return 'Free';
    } else {
      return planData?.plan;
    }
  };

  const remainingPrompts = useSelector(state => state.chat.remainingPrompts);

  const remainingReferrals = useSelector(
    state => state.chat.remainingReferrals
  );
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector(state => state.auth);
  const userData = useSelector(state => state.auth.user);

  const [open, setOpen] = useState(false);

  const wrapperRef = useRef(null);
  const isOpen = useSelector(state => state.utils.isRightSideBarOpen);

  const handleSettings = () => {
    const params = new URLSearchParams(window.location.search);
    navigate(`/settings/profile/?${params.toString()}`);
  };

  const logout = () => {
    localStorage.clear();
    navigate('/sign-in');
    Cookies.remove('chat-model');
    window.location.reload();
  };

  const planDetails = async () => {
    try {
      dispatch.subscription.getPlanData();
    } catch (err) {
      console.log(err.message);
    }
  };

  // Hide Overlay
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        // setShowModel(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line
  }, [wrapperRef]);

  useEffect(() => {
    if (token && userData && !planData) {
      planDetails();
    }
    // eslint-disable-next-line
  }, [userData]);

  return (
    <div className='userdetails'>
      {/* Sign Up Prompts */}

      {/* <OfferSlider /> */}

      <div className='userdetails__main' style={{ paddingTop: '10px' }}>
        {userData && (
          <>
            {isLoggedIn ? (
              <>
                {/* <ReferralProgram /> */}
                {renderPlanType() !== 'year' && (
                  <>
                    <div id='upgrade-btn' style={{ marginBottom: '-10px' }}>
                      <UpgradePrompt
                        plan={planData?.plan}
                        onClick={() => {
                          if (loading || dLoading) {
                            return;
                          } else {
                            dispatch.utils.setSubscriptionModal(true);
                            dispatch.utils.setOpenMobileRightMenu(false);
                          }
                        }}
                      />
                      {!isOpen && (
                        <Tooltip
                          anchorSelect='#upgrade-btn'
                          content='Upgrade Plan'
                          style={{
                            zIndex: '100',
                            background: theme.colors.lightgrey,
                          }}
                        />
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              <div onClick={() => setSignUpModal(true)}>
                <SignUpPrompts />
              </div>
            )}
            <div
              className='user__avatar-box'
              style={{
                flexDirection: isOpen ? 'row' : 'column',
                gap: isOpen ? '' : '10px',
              }}
            >
              <div className='user__data'>
                <img
                  src={userData?.profile?.profile_image || assets.userAvatar2}
                  alt='user data'
                  className='user-avatar'
                />
                {isOpen && (
                  <div className='user-info'>
                    <h1 className='text-capitalize' style={{ margin: '0px' }}>
                      {isLoggedIn == null
                        ? 'New User'
                        : userData?.first_name || userData?.username}
                    </h1>
                    {userData?.profile?.status === 2 ||
                    remainingReferrals > 0 ? (
                      <p id='remaining-prompts'>Unlimited prompts</p>
                    ) : (
                      <p id='remaining-prompts'>
                        {remainingPrompts} Remaining prompts
                      </p>
                    )}
                  </div>
                )}
              </div>
              {/* </Link> */}
              {(loading || dLoading) && !planData ? (
                <Spinner />
              ) : (
                <div
                  className='plan'
                  style={{
                    textTransform: 'capitalize',
                    width: isOpen ? '' : '50px',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    maxWidth: isOpen ? '' : '50px',
                    background:
                      planData?.plan === 'month'
                        ? '#3FDC77'
                        : planData?.plan === 'year'
                        ? '#FF434E'
                        : '#494C54',
                    color: planData?.plan === 'month' ? '#000000' : '#ffffff',
                  }}
                >
                  {renderPlanType()}
                </div>
              )}
            </div>
            {isOpen && remainingReferrals > 0 && (
              <h1
                className='text-capitalize'
                style={{
                  fontSize: '12px',
                  fontWeight: '600',
                  color: '#ffffff',
                  marginTop: '0px',
                  padding: '0px 10px',
                }}
              >
                Referral bonus:{' '}
                <span style={{ fontWeight: '400' }}>
                  {remainingReferrals + ' Days remaining'}
                </span>
              </h1>
            )}
          </>
        )}
        {!isLoggedIn && isOpen && (
          <p
            style={{
              color: 'white',
              marginBottom: '0px',
              paddingTop: '10px',
              paddingLeft: '5px',
              textAlign: 'center',
            }}
          >
            {remainingPrompts + 10} Remaining prompts
          </p>
        )}
        <div
          className='user__info-btn'
          style={{ flexDirection: isOpen ? 'row' : 'column' }}
        >
          {!isLoggedIn ? (
            <>
              <button
                className='login'
                onClick={() => {
                  const params = new URLSearchParams(window.location.search);
                  const buyPlan = params.get('buy_plan');
                  if (buyPlan) {
                    navigate(`/sign-in?buy_plan=true`);
                  } else {
                    navigate('/sign-in');
                  }
                }}
              >
                {isOpen ? (
                  'Login'
                ) : (
                  <svg
                    width='18'
                    height='19'
                    viewBox='0 0 18 19'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M14.68 12.12L17.24 9.56L14.68 7M7 9.56H17.17M9 17.5C4.58 17.5 1 14.5 1 9.5C1 4.5 4.58 1.5 9 1.5'
                      stroke='white'
                      strokeWidth='1.5'
                      stroke-miterlimit='10'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                  </svg>
                )}
              </button>
              <button className='login' onClick={() => setSignUpModal(true)}>
                {isOpen ? (
                  'Sign Up'
                ) : (
                  <svg
                    width='18'
                    height='18'
                    viewBox='0 0 18 18'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M8.75 0C8.33579 0 8 0.335786 8 0.75C8 1.16421 8.33579 1.5 8.75 1.5C10.7906 1.5 12.5986 2.19112 13.891 3.41877C15.1774 4.64078 16 6.43843 16 8.75C16 11.0616 15.1774 12.8592 13.891 14.0812C12.5986 15.3089 10.7906 16 8.75 16C8.33579 16 8 16.3358 8 16.75C8 17.1642 8.33579 17.5 8.75 17.5C11.1294 17.5 13.3214 16.6911 14.924 15.1688C16.5326 13.6408 17.5 11.4384 17.5 8.75C17.5 6.06157 16.5326 3.85922 14.924 2.33123C13.3214 0.808876 11.1294 0 8.75 0ZM8.96033 5.71967C8.66744 5.42678 8.19256 5.42678 7.89967 5.71967C7.60678 6.01256 7.60678 6.48744 7.89967 6.78033L9.17934 8.06H0.75C0.335786 8.06 0 8.39579 0 8.81C0 9.22421 0.335786 9.56 0.75 9.56H9.17934L7.89967 10.8397C7.60678 11.1326 7.60678 11.6074 7.89967 11.9003C8.19256 12.1932 8.66744 12.1932 8.96033 11.9003L11.5203 9.34033C11.8132 9.04744 11.8132 8.57256 11.5203 8.27967L8.96033 5.71967Z'
                      fill='white'
                    />
                  </svg>
                )}
              </button>
            </>
          ) : (
            <>
              {userData?.profile?.status && (
                <button
                  onClick={handleSettings}
                  className='login'
                  id='settings-btn'
                >
                  <div
                    style={{
                      marginRight: isOpen ? '10px' : '0px',
                      display: 'flex',
                      gap: '10px',
                    }}
                  >
                    <img src={assets.settings} alt='' />
                    {isOpen && 'Settings'}
                  </div>
                  {!isOpen && (
                    <Tooltip
                      anchorSelect='#settings-btn'
                      content='Settings'
                      style={{
                        zIndex: '100',
                        background: theme.colors.lightgrey,
                      }}
                    />
                  )}
                </button>
                // <button
                //   onClick={() => setSubscriptionModal(true)}
                //   className='login'
                //   style={{ color: '#ffffff' }}
                // >
                //   Buy Chat-AI Plus
                // </button>
              )}
              <button
                className='logout'
                id='logout'
                onClick={() => setOpen(true)}
              >
                <svg
                  width='28'
                  height='28'
                  viewBox='0 0 28 28'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M21.8794 4.60583H19.5763C19.2709 4.60583 18.978 4.72716 18.7621 4.94311C18.5461 5.15907 18.4248 5.45197 18.4248 5.75737C18.4248 6.06278 18.5461 6.35568 18.7621 6.57163C18.978 6.78759 19.2709 6.90891 19.5763 6.90891H20.7279V20.7274H19.5763C19.2709 20.7274 18.978 20.8487 18.7621 21.0646C18.5461 21.2806 18.4248 21.5735 18.4248 21.8789C18.4248 22.1843 18.5461 22.4772 18.7621 22.6931C18.978 22.9091 19.2709 23.0304 19.5763 23.0304H21.8794C22.1848 23.0304 22.4777 22.9091 22.6937 22.6931C22.9096 22.4772 23.031 22.1843 23.031 21.8789V5.75737C23.031 5.45197 22.9096 5.15907 22.6937 4.94311C22.4777 4.72716 22.1848 4.60583 21.8794 4.60583Z'
                    fill='white'
                  />
                  <path
                    d='M13.5881 8.52104C13.4049 8.27672 13.1321 8.11519 12.8297 8.072C12.5274 8.02881 12.2203 8.10749 11.976 8.29074C11.7316 8.47398 11.5701 8.74678 11.5269 9.04911C11.4837 9.35145 11.5624 9.65856 11.7457 9.90289L13.8184 12.6666H4.60613C4.30072 12.6666 4.00782 12.7879 3.79187 13.0039C3.57591 13.2198 3.45459 13.5127 3.45459 13.8181C3.45459 14.1235 3.57591 14.4164 3.79187 14.6324C4.00782 14.8483 4.30072 14.9697 4.60613 14.9697H13.8184H13.9221L11.9414 17.7794C11.8531 17.9032 11.7901 18.0432 11.7561 18.1915C11.7222 18.3397 11.7179 18.4932 11.7436 18.6431C11.7693 18.793 11.8245 18.9363 11.9058 19.0647C11.9872 19.1932 12.0932 19.3043 12.2178 19.3916C12.4135 19.5282 12.6469 19.6006 12.8857 19.5988C13.0684 19.598 13.2482 19.5537 13.4104 19.4696C13.5726 19.3855 13.7125 19.264 13.8184 19.1152L17.0658 14.509C17.2099 14.3118 17.2875 14.0739 17.2875 13.8296C17.2875 13.5854 17.2099 13.3474 17.0658 13.1502L13.5881 8.52104Z'
                    fill='white'
                  />
                </svg>
                {!isOpen && (
                  <Tooltip
                    anchorSelect='#logout'
                    content='Logout'
                    style={{
                      zIndex: '100',
                      background: theme.colors.lightgrey,
                    }}
                  />
                )}
              </button>
            </>
          )}
        </div>
      </div>
      {/* Logout Confirmation Model */}
      <ConfirmationModel
        open={open}
        setOpen={() => setOpen(!open)}
        action={() => logout()}
        descripiton='Are you sure you want to logout?'
        btnText='Logout'
      />
    </div>
  );
}

export default UserDetails;
